module.exports = __webpack_public_path__ + "static/media/Intro-after-sprakforstaelse.df22e820.mp3";